import { yupResolver } from '@hookform/resolvers/yup';
import { TAssetsDataTableData } from '@Modules/cardManagementSystem/cardholder/containers/dataTableHandler/customerDetail/assetsAndIncome/AssetsDataTableMeta';
import { TIncomeDataTableData } from '@Modules/cardManagementSystem/cardholder/containers/dataTableHandler/customerDetail/assetsAndIncome/IncomeDataTableMeta';
import { IAssetsDataTableRowFormMeta } from '@Modules/cardManagementSystem/cardholder/containers/formHandler/cardData/customerDetail/assetsAndIncome/AssetsDataTableRowFormMeta';
import { I_IncomeDataTableRowFormMeta } from '@Modules/cardManagementSystem/cardholder/containers/formHandler/cardData/customerDetail/assetsAndIncome/IncomeDataTableRowFormMeta';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import React from 'react';
import { useForm } from 'react-hook-form';

type Props = {
    meta: IAssetsDataTableRowFormMeta | I_IncomeDataTableRowFormMeta
    data: TAssetsDataTableData | TIncomeDataTableData
} & TFormUIProps;

export default React.forwardRef(function AssetsAndIncomeDataTableRowFormUI({ onSubmit, isLoading, meta, data }: Props, ref: any) {

    const submitBtnRef = React.useRef<HTMLButtonElement>(null);

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({ defaultValues: data, resolver: yupResolver(meta.schema) });

    React.useImperativeHandle(ref, () => ({
        submitBtnRef
    }));

    return (
        <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)} ref={ref}>
        
            {displayCustomInputs<IAssetsDataTableRowFormMeta | I_IncomeDataTableRowFormMeta>(meta, register, errors, isLoading)}

            <button type={'submit'} ref={submitBtnRef} style={{display: "none"}}>
                Enregistrer
            </button>
        </CC.Box>
    );
});

